<template>
	<div class="homework__item">
		<div class="homework__date"><span class="ico-calendar" uk-tooltip="Уровень"></span> <span>Уровень: {{ item.level }}</span></div>
		<div class="homework__trainer hwtrainer">
			<ul class="hwtrainer__items">
				<li class="hwtrainer__item">
					<div class="homework__content">
						<div class="homework__title">
							{{ item.trainer ? item.trainer.title : item.params.title }}
							<small>
								<span class="uk-badge" uk-tooltip="Количество повторов" v-if="item.trainer_id">{{ item.qnt }}</span>

								<span uk-tooltip="Направление" class="uk-badge" v-if="item.params.direct">{{ item.params.direct ? 'Прямое' : 'Обратное' }}</span>

								<span @click="showAlert(trainer[0])" class="uk-badge" style="cursor: pointer" v-if="item.params.desc">Описание</span>

								<span uk-tooltip="Размер поля" class="uk-badge" v-if="item.params.size">{{ item.params.size }} x {{ item.params.size }}</span>

								<span uk-tooltip="Формула" class="uk-badge" v-if="item.params.formula">
									<i v-if="item.params.formula == '0'">Прямой</i>
									<i v-else-if="item.params.formula == '5'">5-ки</i>
									<i v-else-if="item.params.formula == '10'">10-ки</i>
									<i v-else-if="item.params.formula == '10-5'">5-ки и 10-ки</i>
									<i v-else-if="item.params.formula == '15'">Комбо</i>
									<i v-else-if="item.params.formula == '*'">Микс</i>
								</span>

								<span uk-tooltip="Режим" class="uk-badge" v-if="item.params.mode">{{ item.params.mode === 'train' ? 'Трен' : 'Исп' }}</span>

								<span uk-tooltip="Тип" class="uk-badge" v-if="item.params.type">{{ item.params.type === 'multi' ? 'Умножение' : 'Деление' }}</span>

								<span uk-tooltip="Тип" class="uk-badge" v-if="item.params.direction">{{ item.params.direction ? 'Ч -> А' : 'А -> Ч' }}</span>

								<span uk-tooltip="Слагаемых" class="uk-badge" v-if="item.params.terms">{{ item.params.terms }}</span>

								<span uk-tooltip="Числа" class="uk-badge" v-if="item.params.rank">от {{ split(item.params.rank, '/')[0] }} до {{ split(item.params.rank, '/')[1] }}</span>

								<span uk-tooltip="Количество осей" class="uk-badge" v-if="item.trainer && item.trainer.component == 'flash'">{{ item.params.to }}</span>


								<span uk-tooltip="Разряды" class="uk-badge" v-if="item.params.first"> {{ item.params.first.digits }}, {{ item.params.second.digits }}</span>

								<span uk-tooltip="Скорость, сек" class="uk-badge" v-if="item.params.speed && item.trainer.component !== 'columns'">
									<i v-if="item.trainer_id !== 5">{{ isInt(item.params.speed) }}</i>
									<i v-else-if="item.trainer_id === 5">{{ item.params.mode == 'train' ? 'Нет' : isInt(item.params.speed) }}</i>
								</span>

                <div class="hwit__buttons">
                  <!--<span class="uk-badge uk-badge&#45;&#45;edit" uk-tooltip="Редактировать настройки домашнего задания" uk-icon="pencil" @click="editHW(trainer[0])"></span>-->
                  <span class="uk-badge uk-badge--delete" uk-tooltip="Удалить домашнее задание" uk-icon="close" @click="removeHW(item)"></span>
                </div>
							</small>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
  import swal from "sweetalert";
  import { mapMutations } from 'vuex'

  export default {
    name: "homeworks_ah_item",
    inject: ['http'],
    data() {
      return {
        dates: '',
        group: ''
      }
    },
    props: {
      item: '',
      date: ''
    },
    methods: {
      ...mapMutations({
        deleteTemplate: 'teacher/deleteTemplate'
      }),
      showAlert(item){
        UIkit.modal.dialog(item.homework.params.desc);
      },

	    /** Возвращаем дробное число */
	    isInt(val){
        if(Number.isInteger(val)){
          return val + '.0';
        } else {
          return val;
        }
	    },
      /** Split */
      split(str, razd){
        return str.split(razd);
      },
	    /** Удаление домашки */
	   removeHW(item) {
        swal({
          title: 'Действительно желаете удалить это задание',
          text: "Оно удалится у всех учеников, кому было выдано",
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true,
        })
        .then(async (choise) => {
          if (choise) {
            let data = {
              'id': item.id
            }
            let res = await this.http.post('onRemoveHomework', data).then(res => res.data)
            this.deleteTemplate(item)
          } else {
            console.log('cancel');
          }
        });
      },
      editHW(item) {
        //swal("Скоро! В работе!", "", "warning");
        //console.log('edit', this.item);
        console.log(item);
        this.$parent.$emit('onEditHomework', item.homework);
      },
    },
    mounted() {
      console.log(this.item)
    }
  }
</script>